import React, { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../../../manager'
import CreationToolSuperCutField from '../../../../../types/super-cut-field'
import CreationToolUserRestriction from '../../../../../types/user-restriction'
import { GridBlock } from '../../../../blocks'
import FontField from './fields/font'
import TitleField from './fields/title'
import WatermarkField from './fields/watermark'
import CaptionField from './fields/caption'
// import CropField from './fields/crop'

const Fields = styled(GridBlock)`
    gap: 30px;
    margin: 30px 0;
`

type Props = {
    isEditMode?: boolean
}

const CreationCaptureInfoDetails = ({ isEditMode }: Props) => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)

    // filter out any fields that the user doesn't have access to.
    const fields = CreationToolSuperCutField.all('capture').filter(field => {
        const userRestriction = CreationToolSuperCutField.userRestriction(field)
        const hasAccess = CreationToolUserRestriction.hasAccess(userRestriction, userRestrictionAccess)
        const isEditable = isEditMode ? CreationToolSuperCutField.isEditable(field) : true
        return isEditable && hasAccess
    })

    const fieldComponents = fields.map(field => {
        switch (field) {
            case CreationToolSuperCutField.CaptureTitle:
                return TitleField
            case CreationToolSuperCutField.Caption:
                return CaptionField
            case CreationToolSuperCutField.Watermark:
                return WatermarkField
            case CreationToolSuperCutField.Font:
                return FontField
            // TODO: Un-comment when ready.
            // case CreationToolSuperCutField.Crop:
            //     return CropField
            default:
                return null
        }
    })

    return (
        <Fields columns={2}>
            {fieldComponents.map((Field, i) => (Field ? <Field key={fields[i]} field={fields[i]} /> : null))}
        </Fields>
    )
}

export default CreationCaptureInfoDetails
